var map = {
	"./ClickForSound_1.png": "c993",
	"./ClickForSound_10.png": "7d91",
	"./ClickForSound_11.png": "b577",
	"./ClickForSound_12.png": "b1dd",
	"./ClickForSound_13.png": "ebc4",
	"./ClickForSound_14.png": "97ea",
	"./ClickForSound_15.png": "9483",
	"./ClickForSound_16.png": "29af",
	"./ClickForSound_17.png": "50ac",
	"./ClickForSound_18.png": "d670",
	"./ClickForSound_19.png": "1497",
	"./ClickForSound_2.png": "7306",
	"./ClickForSound_20.png": "aed4",
	"./ClickForSound_21.png": "ac52",
	"./ClickForSound_22.png": "ccf9",
	"./ClickForSound_23.png": "0c37",
	"./ClickForSound_24.png": "b936",
	"./ClickForSound_25.png": "1cce",
	"./ClickForSound_26.png": "e085",
	"./ClickForSound_27.png": "6d85",
	"./ClickForSound_28.png": "4c98b",
	"./ClickForSound_29.png": "2bbc",
	"./ClickForSound_3.png": "5169",
	"./ClickForSound_30.png": "91b2",
	"./ClickForSound_31.png": "526a",
	"./ClickForSound_32.png": "cea6",
	"./ClickForSound_33.png": "4ce3",
	"./ClickForSound_34.png": "683a",
	"./ClickForSound_35.png": "cbb6",
	"./ClickForSound_36.png": "70f1",
	"./ClickForSound_37.png": "6c78",
	"./ClickForSound_38.png": "4a56",
	"./ClickForSound_39.png": "cc6f",
	"./ClickForSound_4.png": "7f37",
	"./ClickForSound_40.png": "c65f",
	"./ClickForSound_5.png": "970be",
	"./ClickForSound_6.png": "524d",
	"./ClickForSound_7.png": "b175",
	"./ClickForSound_8.png": "79b6",
	"./ClickForSound_9.png": "e306"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ba4";